import { Snackbar, Modal, Box, Button, Alert } from "@mui/material";

const EnterpriseModals = ({ snackbar, setSnackbar, openModal, preview, closePreview }) => {
  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Modal open={openModal} onClose={closePreview}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            p: 2,
            borderRadius: 2,
            boxShadow: 24,
            textAlign: "center",
            maxWidth: "90vw",
            maxHeight: "90vh",
          }}
        >
          <img
            src={preview || ""}
            alt="Vista previa"
            style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
          />
          <Box sx={{ mt: 2 }}>
            <Button onClick={closePreview}>Cerrar</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default EnterpriseModals;
